export default __webpack_public_path__ + "static/media/m2_lvCls.c5a3d3e5.png";